export const SUBSCRIPTION_PLANS = {
    payPerDay: 'PayPerDay',
    project: 'Project',
    pro: 'Pro',
    proTeam5: 'ProTeam5',
    proTeam20: 'ProTeam20',
    proTeamUnlimited: 'ProTeamUnlim',
    educator: 'Educator',
    sessionUser: 'SessionUser'
};

export const SUBSCRIPTION_PLANS_ALIAS = {
    payPerDay: 'payg'
};

export const SUBSCRIPTION_PLANS_SETTINGS = {
    PayPerDay: 'PAYG',
    Project: 'Project',
    Pro: 'Pro',
    ProTeam5: 'Pro 5',
    ProTeam20: 'Pro 20',
    ProTeamUnlim: 'Pro Ultd'
};

export const countryList = [
    { value: 'US', label: 'United States', divider: '' },
    { value: 'CA', label: 'Canada', divider: '' },
    { value: 'GB', label: 'United Kingdom', divider: '' },
    { value: 'IN', label: 'India', divider: '' },
    { value: 'AU', label: 'Australia', divider: '' },
    { value: 'RU', label: 'Russia', divider: '' },
    { value: 'DE', label: 'Germany', divider: '' },
    { value: 'CN', label: 'China', divider: '' },
    { value: 'FR', label: 'France', divider: '' },
    { value: 'BR', label: 'Brazil', divider: '' },
    { value: '', label: '', divider: '____________' },

    { value: 'AL', label: 'Albania', divider: '' },
    { value: 'DZ', label: 'Algeria', divider: '' },
    { value: 'AD', label: 'Andorra', divider: '' },
    { value: 'AI', label: 'Anguilla', divider: '' },
    { value: 'AG', label: 'Antigua & Barbuda', divider: '' },
    { value: 'AR', label: 'Argentina', divider: '' },
    { value: 'AM', label: 'Armenia', divider: '' },
    { value: 'AW', label: 'Aruba', divider: '' },
    { value: 'AT', label: 'Austria', divider: '' },
    { value: 'AZ', label: 'Azerbaijan', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'BS', label: 'Bahamas', divider: '' },
    { value: 'BB', label: 'Barbados', divider: '' },
    { value: 'BE', label: 'Belgium', divider: '' },
    { value: 'BZ', label: 'Belize', divider: '' },
    { value: 'BJ', label: 'Benin', divider: '' },
    { value: 'BM', label: 'Bermuda', divider: '' },
    { value: 'BO', label: 'Bolivia', divider: '' },
    { value: 'BA', label: 'Bosnia & Herzegovina', divider: '' },
    { value: 'BW', label: 'Botswana', divider: '' },
    { value: 'IO', label: 'British Virgin Islands', divider: '' },
    { value: 'BN', label: 'Brunei', divider: '' },
    { value: 'BG', label: 'Bulgaria', divider: '' },
    { value: 'BF', label: 'Burkina Faso', divider: '' },
    { value: 'BI', label: 'Burundi', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'KH', label: 'Cambodia', divider: '' },
    { value: 'CM', label: 'Cameroon', divider: '' },
    { value: 'CV', label: 'Cape Verde', divider: '' },
    { value: 'KY', label: 'Cayman Islands', divider: '' },
    { value: 'TD', label: 'Chad', divider: '' },
    { value: 'CL', label: 'Chile', divider: '' },
    { value: 'CO', label: 'Colombia', divider: '' },
    { value: 'KM', label: 'Comoros', divider: '' },
    { value: 'CG', label: 'Congo', divider: '' },
    { value: 'CK', label: 'Cook Islands', divider: '' },
    { value: 'CR', label: 'Costa Rica', divider: '' },
    { value: 'CI', label: 'Côte D’ivoire', divider: '' },
    { value: 'HR', label: 'Croatia', divider: '' },
    { value: 'CY', label: 'Cyprus', divider: '' },
    { value: 'CZ', label: 'Czech Republic', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'DK', label: 'Denmark', divider: '' },
    { value: 'DJ', label: 'Djibouti', divider: '' },
    { value: 'DM', label: 'Dominica', divider: '' },
    { value: 'DO', label: 'Dominican Republic', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'EC', label: 'Ecuador', divider: '' },
    { value: 'EG', label: 'Egypt', divider: '' },
    { value: 'SV', label: 'El Salvador', divider: '' },
    { value: 'EE', label: 'Estonia', divider: '' },
    { value: 'ET', label: 'Ethiopia', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'FK', label: 'Falkland Islands', divider: '' },
    { value: 'FO', label: 'Faroe Islands', divider: '' },
    { value: 'FJ', label: 'Fiji', divider: '' },
    { value: 'FI', label: 'Finland', divider: '' },
    { value: 'GF', label: 'French Guiana', divider: '' },
    { value: 'PF', label: 'French Polynesia', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'GA', label: 'Gabon', divider: '' },
    { value: 'GM', label: 'Gambia', divider: '' },
    { value: 'GE', label: 'Georgia', divider: '' },
    { value: 'GI', label: 'Gibraltar', divider: '' },
    { value: 'GR', label: 'Greece', divider: '' },
    { value: 'GL', label: 'Greenland', divider: '' },
    { value: 'GD', label: 'Grenada', divider: '' },
    { value: 'GP', label: 'Guadeloupe', divider: '' },
    { value: 'GT', label: 'Guatemala', divider: '' },
    { value: 'GN', label: 'Guinea', divider: '' },
    { value: 'GW', label: 'Guinea-Bissau', divider: '' },
    { value: 'GY', label: 'Guyana', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'HN', label: 'Honduras', divider: '' },
    { value: 'HK', label: 'Hong Kong', divider: '' },
    { value: 'HU', label: 'Hungary', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'IS', label: 'Iceland', divider: '' },
    { value: 'ID', label: 'Indonesia', divider: '' },
    { value: 'IE', label: 'Ireland', divider: '' },
    { value: 'IL', label: 'Israel', divider: '' },
    { value: 'IT', label: 'Italy', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'JM', label: 'Jamaica', divider: '' },
    { value: 'JP', label: 'Japan', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'KZ', label: 'Kazakhstan', divider: '' },
    { value: 'KE', label: 'Kenya', divider: '' },
    { value: 'KI', label: 'Kiribati', divider: '' },
    { value: 'KG', label: 'Kyrgyzstan', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'LA', label: 'Laos', divider: '' },
    { value: 'LV', label: 'Latvia', divider: '' },
    { value: 'LS', label: 'Lesotho', divider: '' },
    { value: 'LI', label: 'Liechtenstein', divider: '' },
    { value: 'LT', label: 'Lithuania', divider: '' },
    { value: 'LU', label: 'Luxembourg', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'MK', label: 'Macedonia', divider: '' },
    { value: 'MG', label: 'Madagascar', divider: '' },
    { value: 'MW', label: 'Malawi', divider: '' },
    { value: 'MY', label: 'Malaysia', divider: '' },
    { value: 'MV', label: 'Maldives', divider: '' },
    { value: 'ML', label: 'Mali', divider: '' },
    { value: 'MT', label: 'Malta', divider: '' },
    { value: 'MH', label: 'Marshall Islands', divider: '' },
    { value: 'MQ', label: 'Martinique', divider: '' },
    { value: 'MR', label: 'Mauritania', divider: '' },
    { value: 'MU', label: 'Mauritius', divider: '' },
    { value: 'YT', label: 'Mayotte', divider: '' },
    { value: 'MX', label: 'Mexico', divider: '' },
    { value: 'FM', label: 'Micronesia', divider: '' },
    { value: 'MD', label: 'Moldova', divider: '' },
    { value: 'MC', label: 'Monaco', divider: '' },
    { value: 'MN', label: 'Mongolia', divider: '' },
    { value: 'ME', label: 'Montenegro', divider: '' },
    { value: 'MS', label: 'Montserrat', divider: '' },
    { value: 'MA', label: 'Morocco', divider: '' },
    { value: 'MZ', label: 'Mozambique', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'NA', label: 'Namibia', divider: '' },
    { value: 'NR', label: 'Nauru', divider: '' },
    { value: 'NP', label: 'Nepal', divider: '' },
    { value: 'NL', label: 'Netherlands', divider: '' },
    { value: 'NC', label: 'New Caledonia', divider: '' },
    { value: 'NZ', label: 'New Zealand', divider: '' },
    { value: 'NI', label: 'Nicaragua', divider: '' },
    { value: 'NE', label: 'Niger', divider: '' },
    { value: 'NG', label: 'Nigeria', divider: '' },
    { value: 'NU', label: 'Niue', divider: '' },
    { value: 'NF', label: 'Norfolk Island', divider: '' },
    { value: 'NO', label: 'Norway', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'PW', label: 'Palau', divider: '' },
    { value: 'PA', label: 'Panama', divider: '' },
    { value: 'PG', label: 'Papua New Guinea', divider: '' },
    { value: 'PY', label: 'Paraguay', divider: '' },
    { value: 'PE', label: 'Peru', divider: '' },
    { value: 'PH', label: 'Philippines', divider: '' },
    { value: 'PN', label: 'Pitcairn Islands', divider: '' },
    { value: 'PL', label: 'Poland', divider: '' },
    { value: 'PT', label: 'Portugal', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'QA', label: 'Qatar', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'RE', label: 'Réunion', divider: '' },
    { value: 'RO', label: 'Romania', divider: '' },
    { value: 'RW', label: 'Rwanda', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'WS', label: 'Samoa', divider: '' },
    { value: 'SM', label: 'San Marino', divider: '' },
    { value: 'SA', label: 'Saudi Arabia', divider: '' },
    { value: 'SN', label: 'Senegal', divider: '' },
    { value: 'RS', label: 'Serbia', divider: '' },
    { value: 'SC', label: 'Seychelles', divider: '' },
    { value: 'SL', label: 'Sierra Leone', divider: '' },
    { value: 'SG', label: 'Singapore', divider: '' },
    { value: 'SK', label: 'Slovakia', divider: '' },
    { value: 'SI', label: 'Slovenia', divider: '' },
    { value: 'SB', label: 'Solomon Islands', divider: '' },
    { value: 'SO', label: 'Somalia', divider: '' },
    { value: 'ZA', label: 'South Africa', divider: '' },
    { value: 'KR', label: 'South Korea', divider: '' },
    { value: 'ES', label: 'Spain', divider: '' },
    { value: 'LK', label: 'Sri Lanka', divider: '' },
    { value: 'KN', label: 'St. Kitts & Nevis', divider: '' },
    { value: 'LC', label: 'St. Lucia', divider: '' },
    { value: 'PM', label: 'St. Pierre & Miquelon', divider: '' },
    { value: 'VC', label: 'St. Vincent & Grenadines', divider: '' },
    { value: 'SJ', label: 'Svalbard & Jan Mayen', divider: '' },
    { value: 'SE', label: 'Sweden', divider: '' },
    { value: 'CH', label: 'Switzerland', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'TW', label: 'Taiwan', divider: '' },
    { value: 'TJ', label: 'Tajikistan', divider: '' },
    { value: 'TZ', label: 'Tanzania', divider: '' },
    { value: 'TH', label: 'Thailand', divider: '' },
    { value: 'TG', label: 'Togo', divider: '' },
    { value: 'TO', label: 'Tonga', divider: '' },
    { value: 'TT', label: 'Trinidad & Tobago', divider: '' },
    { value: 'TC', label: 'Turks & Caicos Islands', divider: '' },
    { value: 'TV', label: 'Tuvalu', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'UG', label: 'Uganda', divider: '' },
    { value: 'UA', label: 'Ukraine', divider: '' },
    { value: 'AE', label: 'United Arab Emirates', divider: '' },
    { value: 'UY', label: 'Uruguay', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'VU', label: 'Vanuatu', divider: '' },
    { value: 'VA', label: 'Vatican City', divider: '' },
    { value: 'VN', label: 'Vietnam', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'WF', label: 'Wallis & Futuna', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'YE', label: 'Yemen', divider: '' },
    { value: '', label: '', divider: '-' },

    { value: 'ZM', label: 'Zambia', divider: '' }
];